module.exports = __webpack_public_path__ + "static/media/shower.278de1ac.svg";